import axios from '../../shared/axios';

export function index()
{
    return axios.get('/alerts').then(response => response.data);
}
